import { ComponentStyleConfig } from "@chakra-ui/react";

export const PaymentCard: ComponentStyleConfig = {
  baseStyle: (props) => ({
    cursor: "pointer",
    borderWidth: "1px",
    borderRadius: "md",
    boxShadow: "md",
    _checked: {
      borderColor: "blue.300",
      borderWidth: "2px",
      background:
        "var(--linear, linear-gradient(180deg, rgba(132, 225, 255, 0.60) -30%, rgba(132, 225, 255, 0.00) 130%))",
      boxShadow: "md",
    },
    _focus: {
      boxShadow: "outline",
      borderColor: "blue.300!important",
    },
    px: 5,
    py: 3,
    h: "6rem",
    w: "10rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
  }),
};

export default PaymentCard;
